import * as React from "react";
const Square = (props) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{borderRadius: '3px'}}
  >
    <rect width="11" height="11" rx="1" fill="#F34555" />
  </svg>
);

export default Square;
